import { flushMetaPixelQueue } from '@/composables/useMetaPixel';

export default defineNuxtPlugin((nuxtApp) => {
    if (!process.client) return;

    // Prevent duplicate script injection and initialization
    if (window.__meta_pixel_initialized__) {
        flushMetaPixelQueue();
        return;
    }
    window.__meta_pixel_initialized__ = true;

    const config = useRuntimeConfig();
    const pixelId = (config.public.metaPixelId as string) || '594208351738480';

    // Official Meta Pixel Code
    (function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
            s.parentNode.insertBefore(t, s);
        } else if (b.head) {
            b.head.appendChild(t);
        } else if (b.body) {
            b.body.appendChild(t);
        }
    })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
    );

    try {
        window.fbq!('init', pixelId);
        console.log('[MetaPixel] Initialized Pixel ID:', pixelId);
    } catch (e) {
        console.error('[MetaPixel] Initialization error:', e);
    }

    // Flush any events that were queued in useMetaPixel before initialization
    flushMetaPixelQueue();

    // Initial PageView on initial page load
    try {
        window.fbq!('track', 'PageView');
        console.log('[MetaPixel] Tracked PageView (initial load)');
    } catch (e) {
        console.error('[MetaPixel] Error tracking initial PageView:', e);
    }

    // Track subsequent route changes in Nuxt SPA navigation
    let isInitialNavigation = true;
    nuxtApp.$router.afterEach((to, from) => {
        // Vue Router invokes afterEach for initial route resolution; ignore it since PageView already fired
        if (isInitialNavigation) {
            isInitialNavigation = false;
            if (!from || !from.matched || from.matched.length === 0 || from.name === undefined) {
                return;
            }
        }

        // Fire PageView on actual subsequent navigation
        if (to.fullPath !== from.fullPath) {
            try {
                window.fbq!('track', 'PageView');
                console.log('[MetaPixel] Tracked PageView (route change):', to.fullPath);
            } catch (e) {
                console.error('[MetaPixel] Error tracking route PageView:', e);
            }
        }
    });

    return {
        provide: {
            fbq: window.fbq
        }
    };
});
